module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_R.8e65a8b4.jpg";